/**************************************************
 * Nombre:       Formulario_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {CategoryOutlined, Delete, EmojiFoodBeverageOutlined, Flag} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSPRODUCTO} from "../../../Constantes";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../Servicios/BD/obtenerCol";
import IngresoSelectFuncion from "../../../Modulo_formularios/Componentes/IngresoSelectFuncion";

const Formulario_Producto = ({...props}) => {
    const [categorias, setCategorias] = useState([]);
    const [subCategorias, setSubCategorias] = useState([]);
    const [escogida, setEscogida] = useState({});
    const [seleccionadas, setSeleccionadas] = useState([]);

    const agregarItem = () => {

        let arr = seleccionadas
        let index = arr.findIndex(it => it === escogida);
        if (index === -1) {
            arr.push(escogida)
            props.props.setValue('subcategorias', arr)
        } else {
            alert('La subcategoria ya esta agregada')
        }

    }

    const quitar = (e) => {

        let arr = seleccionadas
        let index = arr.findIndex(it => it === e);
        if (index > -1) {
            arr.splice(index, 1);
            props.props.setValue('subcategorias', arr)
        }

    }

    useEffect(() => {

        let subCats = props.props.getValues('subcategorias')
        if (subCats && subCats.length > 0) {
            console.log(subCats)
            setSeleccionadas(subCats)
        } else {
            setSeleccionadas([])
        }

    }, [props.props.watch('subcategorias')]);

    useEffect(() => {
        obtenerCol('categorias').then(dox => {
            setCategorias(dox.data)
        })

        obtenerCol('subcategorias').then((dox) => {
            setSubCategorias(dox.data)
        })
    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={CategoryOutlined} nombre={'Categoria'} dato={'categoria'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={categorias.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={EmojiFoodBeverageOutlined} nombre={'Nombre del producto'}
                                  dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Descripcion'} dato={'descripcion'} {...props}
                    />
                </Grid>


                <Grid container size={9} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelectFuncion {...props} nombre={'Sub Categorias'} dato={'sub'}
                                          setDato={setEscogida} opciones={subCategorias.map((it) => it.nombre)}/>
                </Grid>

                <Grid container size={3} sx={{justifyContent: 'flex-start'}}>
                    <Button
                        onClick={() => agregarItem()}
                    >Agregar</Button>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={0}
                >

                    {seleccionadas.map((it, index) => {
                        return (
                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'center'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{borderBottom: 1}}
                                >

                                    <Grid container size={10} sx={{justifyContent: 'flex-start'}}>
                                        <Typography>{it}</Typography>
                                    </Grid>

                                    <Grid container size={2} sx={{justifyContent: 'flex-end'}}>
                                        <IconButton
                                            onClick={() => quitar(it)}
                                        >
                                            <Delete/>
                                        </IconButton>
                                    </Grid>

                                </Grid>
                            </Grid>
                        )
                    })}

                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto